exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "/**\n * Any styles specific to the Product module should live here.  Import as needed.\n */\n\n.modules-product-___productModuleStyles__product-list___2NOuF {\n  /*padding: 20px;*/\n}\n\n.modules-product-___productModuleStyles__list-item___1bUrh {\n  list-style: none;\n  margin: 10px 0;\n  border-bottom: 1px solid #dfefef;\n  padding: 4px 10px;\n  transition: all ease-in-out 250ms;\n\n}\n\n.modules-product-___productModuleStyles__list-item___1bUrh:hover {\n  box-shadow: 1px 12px 24px rgba(0,0,0,0.15);\n}\n", ""]);

// exports
exports.locals = {
	"product-list": "modules-product-___productModuleStyles__product-list___2NOuF",
	"list-item": "modules-product-___productModuleStyles__list-item___1bUrh"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./modules/product/productModuleStyles.css
// module id = 1352
// module chunks = 1